/* AF · CROSS-SELL · estado compartilhado da página · v3 · 12/08/2026

   v3 mudou a unidade de conta: a soma passou a ser da PÁGINA INTEIRA,
   não de um contêiner. Qualquer cross-sell — vários blocos dentro do
   AF · Produto, mais quantas seções independentes existirem — entra no
   mesmo total, e o aviso sai no `document` para que todo mundo escute.

   Contrato público, em window.AF:
     AF.itensXS         → array dos itens ligados na página agora
     AF.itensDaPagina() → recalcula e devolve
     AF.itensDe(raiz)   → só os de um contêiner
     AF.brl(centavos)   → formata
   Eventos no document:
     af:crosssell  detail:{itens}     — emitido por este arquivo
     af:variante   detail:{variante}  — emitido pelo AF · Produto
   Função que o AF · Produto publica:
     AF.adicionar() → Promise. Manda principal + extras. Ausente se
                      não houver AF · Produto na página.

   ORDEM IMPORTA: as chaves de AF são publicadas ANTES do init().
   Se fossem depois, o `AF.itensXS = []` sobrescreveria a lista que o
   próprio init() acabou de calcular — hoje inofensivo, porque nenhum
   card nasce ligado, e uma bomba no dia em que algum nascer. */
(function(){
  var AF = (window.AF = window.AF || {});

  function brl(c){ return (c/100).toLocaleString('pt-BR',{style:'currency',currency:'BRL'}); }

  function selecionado(it){
    var sel = it.querySelector('[data-af-xs-var]');
    if(!sel) return { id: it.dataset.varid, preco: parseInt(it.dataset.preco||'0',10), de:0 };
    if(sel.tagName === 'SELECT'){
      var o = sel.options[sel.selectedIndex];
      return { id: sel.value, preco: parseInt((o&&o.dataset.preco)||'0',10), de: parseInt((o&&o.dataset.de)||'0',10) };
    }
    if(sel.tagName === 'INPUT'){
      return { id: sel.value, preco: parseInt(sel.dataset.preco||'0',10), de:0 };
    }
    var b = it.querySelector('.af-xsi__box[aria-pressed="true"]:not(:disabled)') || it.querySelector('.af-xsi__box');
    return { id: b.value, preco: parseInt(b.dataset.preco||'0',10), de: parseInt(b.dataset.de||'0',10) };
  }

  function pintaItem(it){
    var s = selecionado(it);
    var p = it.querySelector('[data-af-xs-preco]');
    var d = it.querySelector('[data-af-xs-de]');
    if(p) p.textContent = brl(s.preco);
    if(d){
      if(s.de > s.preco){ d.textContent = brl(s.de); d.style.display=''; }
      else d.style.display='none';
    }
  }

  function itensDe(raiz){
    var lista = [];
    if(!raiz) return lista;
    raiz.querySelectorAll('[data-af-xs-item]').forEach(function(it){
      if(it.getAttribute('aria-pressed') === 'true') lista.push(selecionado(it));
    });
    return lista;
  }

  function itensDaPagina(){
    var lista = [];
    document.querySelectorAll('[data-af-xs]').forEach(function(raiz){
      lista = lista.concat(itensDe(raiz));
    });
    AF.itensXS = lista;
    return lista;
  }

  function avisa(){
    document.dispatchEvent(new CustomEvent('af:crosssell',{ detail:{ itens: itensDaPagina() } }));
  }

  function ligar(raiz){
    if(raiz.dataset.afXsReady) return;
    raiz.dataset.afXsReady = '1';

    raiz.querySelectorAll('[data-af-xs-item]').forEach(function(it){
      pintaItem(it);

      var t = it.querySelector('[data-af-xs-toggle]');
      if(t) t.addEventListener('click', function(){
        var on = it.getAttribute('aria-pressed') !== 'true';
        it.setAttribute('aria-pressed', on ? 'true' : 'false');
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
        avisa();
      });

      var sel = it.querySelector('[data-af-xs-var]');
      if(sel && sel.tagName === 'SELECT'){
        sel.addEventListener('change', function(){ pintaItem(it); avisa(); });
      }

      it.querySelectorAll('.af-xsi__box').forEach(function(bx){
        bx.addEventListener('click', function(e){
          e.stopPropagation();
          it.querySelectorAll('.af-xsi__box').forEach(function(x){ x.setAttribute('aria-pressed','false'); });
          bx.setAttribute('aria-pressed','true');
          pintaItem(it); avisa();
        });
      });
    });
  }

  // Um aviso só no fim, com a página toda contada — e não um por contêiner.
  function init(){
    document.querySelectorAll('[data-af-xs]').forEach(ligar);
    avisa();
  }

  // Publica o contrato ANTES de rodar. Ver a nota de ordem no topo.
  AF.brl = brl;
  AF.itensXS = [];
  AF.itensDe = itensDe;
  AF.itensDaPagina = itensDaPagina;
  AF.recontar = avisa;
  window.afCrossSell = { itens: itensDaPagina, ativos: itensDe, brl: brl };

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // O editor de tema re-renderiza sections: religa ao trocar de bloco.
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', init);
})();
